import { StateParams, StateProvider, StateService } from "@uirouter/angularjs";
import { vsComponentName as processGridComponentName } from "./views/ProcessInstancesGrid";
import {
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../records/views/recordGridView";
import { processInstancesName } from "./config/objects";
import {
  ProcessInformationService,
  vsServiceName as ProcessInformationServiceName,
} from "./services/processInformationService";
import { ProcessGroup, ProcessInformation } from "./model/ProcessGroups";
import { IScope } from "angular";
import { IGridSettings } from "../records/grids/settings/gridSettingsService";
import { ColDef } from "../records/grids/columns/colDef";

import {
  vsName as ColumnDefinitionServiceName,
  ColumnDefinitionService,
} from "../records/grids/columns/columnDefinitionService";
import { getProcessDetailState } from "./config";
import { vsComponentName as ProcessNotesModalComponentName } from "./views/processDetail/notes";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../records/server/serverUtility";
import {
  ProcessApiResponse,
  ProcessInstancesNotesView,
  ProcessState,
} from "./model/ProcessApi";
import { ProcessNotesComponentController } from "./views/processDetail/notes/controller";
import {
  vsComponentName as formViewComponentName,
  FormViewController,
  FormViewService,
  vsServiceName as FormViewServiceName,
} from "../records/forms/formView";
import fieldHelpers from "../ui-formly/fieldHelpers";
import { ServiceResponse } from "../records/server/query";
import { addRoute as addProcessNoteRoutes } from "./views/processDetail/notes/route";

routeConfig.$inject = ["$stateProvider"];

const baseRoute = "main.processes";

export function routeConfig($stateProvider: StateProvider) {
  $stateProvider
    .state(baseRoute, {
      abstract: true,
      template: "<ui-view></ui-view>",
      url: "processes",
    })
    .state(`${baseRoute}.grid`, {
      url: "",
      component: processGridComponentName,
      resolve: {
        gridConfiguration: [
          RecordGridViewServiceName,
          (recordGridViewService: RecordGridViewService) =>
            recordGridViewService.getGridConfiguration(processInstancesName),
        ],
        processGroups: [
          ProcessInformationServiceName,
          (processInformationService: ProcessInformationService) =>
            processInformationService.getAuthorizedGetProcessGroups(),
        ],
      },
    })
    .state(`${baseRoute}.grid.group`, {
      url: "/{groupId:[^/]+}",
      template:
        require("!html-loader!./views/ProcessInstancesGrid/groupTemplate.html")
          .default,
      controller: [
        "$scope",
        "processGroup",
        "gridSettings",
        "additionalGridColumns",
        ProcessInformationServiceName,
        (
          s: IScope,
          processGroup: ProcessGroup,
          gridSettings: IGridSettings,
          additionalGridColumns: ColDef[],
          processInformationService: ProcessInformationService
        ) => {
          const $scope = <any>s;
          $scope.processGroup = processGroup;
          $scope.gridSettings = gridSettings;
          $scope.onNewProcessSelected = (process: ProcessInformation) =>
            processInformationService
              .createNewProcessFlow(processGroup, process)
              .then((processResponse) =>
                processInformationService.navigateToDetail(processResponse)
              );
          $scope.defaultQuery = undefined;
          $scope.additionalGridColumns = additionalGridColumns;
        },
      ],
      resolve: {
        groupId: [
          "$stateParams",
          ($stateParams: StateParams) => $stateParams.groupId,
        ],
        processGroup: [
          "groupId",
          ProcessInformationServiceName,
          (
            groupId: string,
            processInformationService: ProcessInformationService
          ) => processInformationService.getProcessGroup(groupId),
        ],
        gridSettings: [
          ProcessInformationServiceName,
          "processGroup",
          (
            processInformationService: ProcessInformationService,
            processGroup: ProcessGroup
          ) => processInformationService.getGridSettings(processGroup),
        ],
        additionalGridColumns: [
          "processGroup",
          ProcessInformationServiceName,
          ColumnDefinitionServiceName,
          (
            processGroup: ProcessGroup,
            processInformationService: ProcessInformationService,
            columnDefinitionService: ColumnDefinitionService
          ) => [
            columnDefinitionService.getLinkColDef({
              headerName: "info",
              iconClass: "fa fa-info-circle text-primary",
              colId: "detail",
              width: 20,
              stateExpression: `main.processes.grid.detail({  processInstancesId: data.Id, groupId: Group})`,
            }),
            ...processInformationService.getAdditionalGridColumns(processGroup),
          ],
        ],
      },
    })
    .state(
      `${baseRoute}.grid.group.detail`,
      getProcessDetailState([
        "processGroup",
        ProcessInformationServiceName,
        (
          processGroup: ProcessGroup,
          processInformationService: ProcessInformationService
        ) => processInformationService.getDetailTemplate(processGroup.Id),
      ])
    );
  addProcessNoteRoutes($stateProvider, `${baseRoute}.grid.group.detail.notes`);
  // .state(`${baseRoute}.grid.group.detail.notes`, {
  //   component: ProcessNotesModalComponentName,
  //   url: "/notes",
  //   params: {
  //     state: undefined,
  //   },
  //   resolve: {
  //     state: [
  //       "$stateParams",
  //       ($stateParams: StateParams) => $stateParams.state,
  //     ],
  //   },
  // })
  // .state(`${baseRoute}.grid.group.detail.notes.add`, {
  //   component: formViewComponentName,
  //   url: "/add",
  //   resolve: {
  //     fields: [
  //       "process",
  //       (process: ProcessApiResponse<any>) => {
  //         const states = process.States.filter((s) =>
  //           ["InProgress", "Complete"].includes(s.StatusCategory)
  //         ).map((s) => ({
  //           value: s.Id,
  //           name: s.Name,
  //         }));

  //         return [
  //           ...fieldHelpers.columnLayout(
  //             [
  //               fieldHelpers.selectField({
  //                 key: "StateId",
  //                 required: true,
  //                 options: states,
  //               }),
  //             ],
  //             4
  //           ),
  //           ...fieldHelpers.columnLayout(
  //             [
  //               fieldHelpers.simpleStringField({
  //                 key: "Notes",
  //                 label: "Note",
  //                 required: true,
  //               }),
  //             ],
  //             1
  //           ),
  //         ];
  //       },
  //     ],
  //     model: [
  //       "process",
  //       "state",
  //       (process: ProcessApiResponse<any>, state: ProcessState) => ({
  //         StateId: process.States.find((s) => s.Id === state?.Id)?.Id,
  //       }),
  //     ],
  //     title: [() => "Add Note"],
  //     onSubmit: [
  //       FormViewServiceName,
  //       "process",
  //       "$state",
  //       (
  //         formViewService: FormViewService,
  //         process: ProcessApiResponse<any>,
  //         $state: StateService
  //       ) => [
  //         "formViewController",
  //         "model",
  //         (formViewController: FormViewController, model: any) =>
  //           formViewService
  //             .submitForm<ServiceResponse<ProcessInstancesNotesView>>({
  //               formObject: model,
  //               formViewController,
  //               method: "POST",
  //               url: `/api/processes/instances/${process.Id}/notes`,
  //             })
  //             .then((r) => $state.go("^", undefined, { reload: true })),
  //       ],
  //     ],
  //     onCancel: ["$state", ($state: StateService) => [() => $state.go("^")]],
  //     showButtonsAtTop: [() => false],
  //   },
  // });
}
